import Swiper from "swiper";
import $ from 'jquery';
import SubPage from "../SubPage";
import { PAGE_KEY_INSIGHTS } from "../constants";
import gsap from "gsap";

export default class FrameworkMobile {
    constructor() {
        this.framework = document.querySelector('#framework')
        this.frameworkMobileContainer = document.querySelector('#framework .framework-mobile-container')
        this.frameworkSlide = document.querySelectorAll('#framework .framework-mobile-container .swiper-slide')
        this.frameworkSwiper = null

        this.slideNext = $('.framework-mob-navigation .next_btn')
        this.slidePrev = $('.framework-mob-navigation .prev_btn')

        this.init()
    }

    init() {

        this.frameworkSwiper = new Swiper(this.frameworkMobileContainer, {
            slidesPerView: 1,
            spaceBetween: 10,
            allowTouchMove: true,
            on: {
                init: (instance) => {
                    const paginationBullets = document.querySelectorAll('.framework-mob-navigation .framework-mob-pagination .swiper-pagination-bullet')
                    paginationBullets.forEach(b => b.classList.remove('active'))
                    paginationBullets[instance.activeIndex]?.classList.add('active')
                    // instance.slideTo(3)
                },
                slideChange: (instance) => {
                    const paginationBullets = document.querySelectorAll('.framework-mob-navigation .framework-mob-pagination .swiper-pagination-bullet')
                    paginationBullets.forEach(b => b.classList.remove('active'))
                    paginationBullets[instance.activeIndex]?.classList.add('active')
                    this.animationControl(instance.activeIndex)
                }
            }
        })

        this.slideNext.on('click', () => {
            this.frameworkSwiper.slideNext();
        });

        this.slidePrev.on('click', () => {
            this.frameworkSwiper.slidePrev();
        });

        $('.framework-mob-navigation .framework-mob-pagination .swiper-pagination-bullet').on('click', (e) => {
            const index = $(e.currentTarget).index();
            this.frameworkSwiper.slideTo(index);
        })

        this.keyInsightsBtn = document.querySelector('.framework-mobile-container .framework-btn-block #keyInsightsBtn')

        this.keyInsightsBtn.addEventListener('click', () => {
            SubPage.getInstance().showKeyInsightsPage()
            SubPage.setCurrentPage(PAGE_KEY_INSIGHTS)
        })

        this.animation()
    }

    animation() {
        this.domElement()
        this.gsapInit()
        this.gsapAnimate()
    }


    domElement() {
        this.frameworkSlide02 = $('.framework-mobile-container .framework-slide-02')
        this.frameworkSlide03 = $('.framework-mobile-container .framework-slide-03')
        this.frameworkSlide04 = $('.framework-mobile-container .framework-slide-04')

        this.slide02Title = this.frameworkSlide02.find('.section_title .sec_title')
        this.slide02Desc = this.frameworkSlide02.find('.section_title .paragraph')
        this.slide02SecCol = this.frameworkSlide02.find('.section-grid-block .section-col')

        this.slide03Title = this.frameworkSlide03.find('.section_title .sec_title')
        this.slide03Desc = this.frameworkSlide03.find('.section_title .paragraph')
        this.slide03SecCol = this.frameworkSlide03.find('.section-grid-block .section-col')

        this.slide04Title = this.frameworkSlide04.find('.section_title .sec_title')
        this.slide04Desc = this.frameworkSlide04.find('.section_title .paragraph')
        this.slide04SecCol = this.frameworkSlide04.find('.section-grid-block .section-col')
        this.slide04cardBlocks = this.frameworkSlide04.find('.section-grid-block .section-col .card-block')
        this.slide04ImgTitles = this.frameworkSlide04.find('.section-grid-block .section-col .card-block .img-title')
    }

    gsapInit() {
        gsap.set(this.slide02Title, { y: 100, opacity: 0 })
        gsap.set(this.slide02Desc, { y: 100, opacity: 0 })
        gsap.set(this.slide02SecCol, { y: 100, opacity: 0 })

        gsap.set(this.slide03Title, { y: 100, opacity: 0 })
        gsap.set(this.slide03Desc, { y: 100, opacity: 0 })
        gsap.set(this.slide03SecCol, { y: 100, opacity: 0 })

        gsap.set(this.slide04Title, { y: 100, opacity: 0 })
        gsap.set(this.slide04Desc, { y: 100, opacity: 0 })
        gsap.set(this.slide04SecCol, { y: 100, opacity: 0 })

        gsap.set(this.slide04cardBlocks, {scale:0})
        gsap.set(this.slide04ImgTitles, {y:-30, opacity: 1})

        this.fmTl02 = gsap.timeline({ paused: true })
        this.fmTl03 = gsap.timeline({ paused: true })
        this.fmTl04 = gsap.timeline({ paused: true })
    }

    gsapAnimate() {
        // FM TIMELINE 01
        this.fmTl02.to(this.slide02Title, {
            duration: 1,
            opacity: 1,
            y: 0
        }, 0.5)
            .to(this.slide02Desc, {
                duration: 1,
                opacity: 1,
                y: 0
            }, '-=.5')
            .to(this.slide02SecCol, {
                duration: 1,
                opacity: 1,
                y: 0,
                stagger: 0.3
            }, '-=.2')

        // FM TIMELINE 02
        this.fmTl03.to(this.slide03Title, {
            duration: 1,
            opacity: 1,
            y: 0
        }, 0.5)
            .to(this.slide03Desc, {
                duration: 1,
                opacity: 1,
                y: 0
            }, '-=.5')
            .to(this.slide03SecCol, {
                duration: 1,
                opacity: 1,
                y: 0,
                stagger: 0.3
            }, '-=.2')

        // FM TIMELINE 03
        this.fmTl04.to(this.slide04Title, {
            duration: 1,
            opacity: 1,
            y: 0
        }, 0.5)
            .to(this.slide04Desc, {
                duration: 1,
                opacity: 1,
                y: 0
            }, '-=.5')
            .to(this.slide04SecCol, {
                duration: 1,
                opacity: 1,
                y: 0,
            }, '-=.2')
            .to(this.slide04cardBlocks, {
                duration: 1,
                scale:1,
                stagger:0.2
            }, '-=.2')
            .to(this.slide04ImgTitles, {
                duration: 1,
                opacity:1,
                y:0,
            }, '-=.2')


    }


    animationControl(index) {
        this.resetSlides()
        switch (index) {
            case 0:

                break;
            case 1:
                this.fmTl02.restart()
                break;
            case 2:
                this.fmTl03.restart()
                break;
            case 3:
                this.fmTl04.restart()
                break;

            default:
                break;
        }
    }

    resetSlides() {
        this.fmTl02.timeScale(2).reverse()
        this.fmTl03.timeScale(2).reverse()
        this.fmTl04.timeScale(2).reverse()
    }

    resetMobFramework(){
        this.frameworkSwiper.slideTo(0)
    }

}